import React from 'react'
import AvatarProfile from '../../components/avatar'
import MultiTabFundingRequest from '../Ops/multi-tabs-funding-request'

const CapPcpage = () => {
  return (
        <div className='w-screen'>
            <AvatarProfile />
            <MultiTabFundingRequest status='RISK-APPROVED, RISK-APPROVED-EXCEPTION, CPTY-APPROVED' stage='Initial' />
        </div>
  )
}

export default CapPcpage
